import { Reveal, SectionTag } from "./shared";
import { useLanguage } from "@/i18n/LanguageContext";

const PROCESS_IMG = "/images/kalender-cbs.jpg";

export const Process = () => {
    const { t } = useLanguage();
    return (
        <section id="process" data-testid="process-section" className="relative py-24 md:py-32">
            <div className="mx-auto max-w-[1400px] px-6 md:px-12">
                <Reveal>
                    <SectionTag index="№ 03" label={t.process.tag} />
                </Reveal>
                <div className="mt-12 grid grid-cols-1 gap-16 md:grid-cols-12">
                    <div className="md:col-span-5">
                        <div className="md:sticky md:top-32">
                            <Reveal>
                                <h2 className="font-display text-4xl leading-[1.05] tracking-tight md:text-5xl">
                                    {t.process.headingA}{" "}
                                    <span className="italic text-gold">{t.process.headingB}</span>.
                                </h2>
                            </Reveal>
                            <Reveal delay={0.15} className="mt-10">
                                <div className="group relative overflow-hidden border border-white/10">
                                    <img
                                        src={PROCESS_IMG}
                                        alt="Clarke Business Solutions planning"
                                        className="animate-kenburns aspect-[4/5] w-full object-cover"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                                    <p className="absolute bottom-6 left-6 font-display text-xl italic text-bone">
                                        {t.process.imageCaption}
                                    </p>
                                </div>
                            </Reveal>
                        </div>
                    </div>
                    <div className="md:col-span-7">
                        {t.process.steps.map((s, i) => (
                            <Reveal
                                key={s.n}
                                delay={i * 0.08}
                                className={`group border-t border-white/10 ${
                                    i === t.process.steps.length - 1 ? "border-b" : ""
                                }`}
                            >
                                <div
                                    data-testid={`process-step-${s.n}`}
                                    className="flex flex-col gap-4 py-10 transition-all duration-500 group-hover:bg-gold/[0.03] group-hover:pl-4 sm:flex-row sm:items-baseline sm:gap-10"
                                >
                                    <span className="font-display text-5xl italic text-gold/70 transition-colors duration-500 group-hover:text-gold md:text-6xl">
                                        {s.n}
                                    </span>
                                    <div>
                                        <h3 className="font-display text-2xl tracking-tight text-bone md:text-3xl">
                                            {s.title}
                                        </h3>
                                        <p className="mt-3 max-w-lg text-base leading-relaxed text-ash">
                                            {s.body}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
